import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65dd717d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tags-view-container" }
const _hoisted_2 = { class: "icon" }

import { shallowRef ,computed,watch} from 'vue';
import { useRoute,useRouter } from 'vue-router'
import { useStore } from 'vuex';
import KlIcon from '@/components/icon-picker/KLIcon.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const router = useRouter()
const route: any = useRoute()

 const language = computed(() => {
    return store.getters.language
  })

const isActive = (rou) => {  //选中
    return rou.fullPath == route.fullPath
}
const visitedViews = computed(()=>{
    return store.state.tagsView.visitedViews
})
console.log('visitedViews',visitedViews.value);
//添加
const addViewTags = ()=> {
    if(!route.name) return false;
   store.dispatch('addVisitedViews',route)
}
addViewTags()

//删除
const closeSelectedTag = (tag)=> {
   store.dispatch('delVisiteViews',tag).then((e)=>{
       if(isActive(tag)){   
        const latestView = e.slice(-1)[0]
        if(latestView){      
           router.push(latestView.fullPath)  
        }else{
            router.push('/') 
        }
       }
   }) 
}
watch(()=>route.path,()=>{
 addViewTags() 
console.log('isActive',isActive);

 
 
})


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.from(_unref(visitedViews)), (tag) => {
      return (_openBlock(), _createBlock(_component_router_link, {
        class: _normalizeClass(["tags-view-item", isActive(tag)?'active':'']),
        to: tag.fullPath,
        key: tag.fullPath,
        onContextmenu: _withModifiers(($event: any) => (_ctx.openMenu(tag,$event)), ["prevent"])
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(language) === 'en' ? tag.meta.title_en : tag.meta.title) + " ", 1),
          _createElementVNode("span", _hoisted_2, [
            _createVNode(KlIcon, {
              size: "14",
              icon: "bx-x",
              onClick: _withModifiers(($event: any) => (closeSelectedTag(tag)), ["prevent","stop"])
            }, null, 8, ["onClick"])
          ])
        ]),
        _: 2
      }, 1032, ["class", "to", "onContextmenu"]))
    }), 128))
  ]))
}
}

})